import {
	ElMessage
} from 'element-plus'
import defaultSettings from '@/settings'
import useUserStore from '@/store/modules/user'
import {
	logout,
	sysmenuMenuList,
	globalCacheSave,
	fileDownloadFile,
	globalCacheQuery,
	globalCacheDelete,
	cacheGetCacheType,
	sysmenupowerPowerIn,
	fileDownloadFileUrl,
	cacheUpdateCacheType,
	fileUpdateExportStatus,
	globalCacheSaveWhereNow
} from '@/api/user'
import {
	projecttrackingprojectPowerAbout,
	projecttrackingrequirementCheckShare
} from '@/api/project'
import {
	archiverecordCheckUserArchive
} from '@/api/archivePage'
import {
	sysuserCheckUserExist,
	sysuserCancelRemovePrecheck
} from '@/api/groupAccount'
import router from '@/router'
import {
	onMounted,
	ref,
} from 'vue'

const messageItemOld = ref(null) // 缓存上一条消息数据
const messageQueue = ref([]) // 假设你有一个消息队列

const userInfo = computed(() => {
	return useUserStore().userInfo
})
const projectConfigData = computed(() => {
	return useUserStore().projectConfigData
})
// 配置数据
const userConfigData = computed(() => {
	return useUserStore().userConfigData
})

// 响应式文件名截取长度
const fileNameCutLength = ref(44)

// 根据屏幕宽度调整截取长度
export function updateFileNameCutLength() {
	const screenWidth = window.innerWidth
	if (screenWidth < 1080) {
		fileNameCutLength.value = 24
	} else if (screenWidth < 1280) {
		fileNameCutLength.value = 28
	} else if (screenWidth < 1440) {
		fileNameCutLength.value = 32
	} else if (screenWidth < 1600) {
		fileNameCutLength.value = 32
	} else if (screenWidth < 1760) {
		fileNameCutLength.value = 36
	} else {
		fileNameCutLength.value = 44
	}

	return fileNameCutLength
}

// 文件名显示逻辑
export function getFileNameParts(fileName) {
	if (!fileName) return {
		firstPart: '-',
		secondPart: ''
	}

	if (fileName.length <= fileNameCutLength.value) {
		return {
			firstPart: fileName,
			secondPart: ''
		}
	}

	return {
		firstPart: fileName.substring(0, fileNameCutLength.value),
		secondPart: fileName.substring(fileNameCutLength.value)
	}
}

// 保存时手动设置当前默认字号
export function setDefaultFontSizeToP(html, fontSize = '13px') {
	const parser = new DOMParser();
	const doc = parser.parseFromString(html, 'text/html');
	const paragraphs = doc.querySelectorAll('p');
	paragraphs.forEach(p => {
		// 设置内联 font-size（保留其他样式）
		p.style.fontSize = fontSize;
	});

	// 返回 body 内的 HTML 字符串（去掉了 <html><head> 等多余部分）
	return doc.body.innerHTML;
}

// 获取百分比
export function getPercentage(val, total) {
	console.log(val, total)
	if (val === 0 || total === 0) {
		return 0
	} else {
		let data = Math.round(val / total * 100 * 100) / 100
		return isNaN(data) ? 0 : data
	}
}

/**
 * 将字符串中每个单词的首字母转换为小写
 * @param {string} str - 输入字符串
 * @returns {string} - 转换后的字符串
 */
export function lowerCaseFirstLetterOfEachWord(str) {
	if (!str) return str
	// 使用正则匹配单词边界，\b 匹配单词边界，\w 匹配单词字符
	// 替换每个单词的第一个字符为小写
	return str.replace(/\b\w/g, (match) => match.toLowerCase())
}

// 成员看板-效率表单/年度比较-默认折线数据
export function getLineDefaultData(arr, no) {
	let seriesData = []
	let data = no ? [] : ['完成总量']
	let colorData = no ? [] : [{
		color: '#FF6F53',
		borderColor: 'rgba(255, 111, 83, 0.3)'
	}]

	const legendData = data.concat(['年度数量', '一季度', '二季度', '三季度', '四季度'])
	const itemData = colorData.concat([{
		color: '#B8B4FF',
		borderColor: 'rgba(184, 180, 255, 0.3)'
	}, {
		color: '#53FF97',
		borderColor: 'rgba(83, 255, 151, 0.3)'
	}, {
		color: '#FFC941',
		borderColor: 'rgba(255, 201, 65, 0.3)'
	}, {
		color: '#E3FF53',
		borderColor: 'rgba(227, 255, 83, 0.3)'
	}, {
		color: '#366AFF',
		borderColor: 'rgba(54, 106, 255, 0.3)'
	}])

	legendData.map((item, index) => {
		let obj = itemData[index]
		seriesData.push({
			name: item,
			type: 'line',
			symbol: 'circle',
			symbolSize: 5, // 点标记大小
			itemStyle: {
				color: obj.color,
				borderColor: obj.borderColor,
				borderWidth: 10
			},
			data: arr && arr.length > 0 ? arr[index] : []
		})
	})

	return {
		legendData,
		seriesData
	}
}

// 获取缓存状态
// track_centre 项目追踪-项目中心  track_todo 项目追踪-我的待办  track_create 项目追踪-我的创建
// archive_member_type 档案库-成员档案  archive_overall_type 档案库-综合档案  archive_warning_type 档案库-档案预警
// archive_device_register_type 档案库-设备登记  archive_device_approve_type 档案库-设备审批
// archive_overall_material_type 档案库-综合档案-材料类型  archive_device_type 档案库-设备登记-设备类别
// export function cacheGetCacheTypeApi(type) {
// 	console.log(type, 'typetypetypetype')
// 	cacheGetCacheType({
// 		type
// 	}).then(res => {
// 		if (res) {
// 			console.log(res.data, 'resresresres')
// 			return res.data
// 		}
// 	}).catch(e => {
// 		setMessageQueue('error', e)
// 		console.log(e)
// 	})
// }

// 获取确认/保存按钮展示 shift+enter 时才会加⌜⌟标识  isSpecial => enter
export function getSureText(text, isSpecial) {
	let data = userConfigData.value.shortcutModelArr || []
	let str = ''

	if (isSpecial) {
		// 需要特殊处理的
		str = (data.includes(2) ? '⌜' : '') + text + (data.includes(2) ? '⌟' : '')
	} else {
		str = (data.includes(1) ? '⌜' : '') + text + (data.includes(1) ? '⌟' : '')
	}

	return str
}

// 获取取消按钮展示
export function getCancelText() {
	let data = userConfigData.value.shortcutModelArr || []
	return (data.includes(3) ? '⌜' : '') + '取消' + (data.includes(3) ? '⌟' : '')
}

// 输入时过滤非数字字符 正数+小数点后两位
export function handleRegexInputPositiveNumberAndDecimalPoint(value) {
	// 移除所有非数字和小数点的字符
	let filtered = value ? value.replace(/[^\d.]/g, '') : '';

	// 确保只有一个小数点
	const decimalCount = (filtered.match(/\./g) || []).length;
	if (decimalCount > 1) {
		filtered = filtered.replace(/\.+$/, '');
	}

	// 限制小数点后最多两位
	if (filtered.includes('.')) {
		const parts = filtered.split('.');
		if (parts[1].length > 2) {
			filtered = parts[0] + '.' + parts[1].substring(0, 2);
		}
	}

	console.log(filtered, 'filtered')

	// 如果以小数点开头，在前面加0
	if (filtered.startsWith('.')) {
		filtered = '0' + filtered;
	}

	return filtered
}

// 输入时过滤非数字字符 正整数0-99999999
export function handleRegexInput(value) {
	let demoStr = 99999999
	// 移除所有非数字字符
	let filtered = value.replace(/[^\d]/g, '');

	// 移除前导零（除非是单个0）
	if (filtered.length > 1 && filtered.startsWith('0')) {
		filtered = filtered.replace(/^0+/, '');
	}

	// 如果为空，设置为空字符串
	if (filtered === '') {
		return filtered;
	}

	// 转换为数字并确保是正整数
	let numValue = parseInt(filtered, 10);
	if (isNaN(numValue) || numValue < 0) {
		return '';
	} else if (numValue > demoStr) {
		return numValue.toString().slice(0, demoStr.toString().length)
	} else {
		return numValue.toString();
	}
}

// 存入缓存页（EnterprisedetailsDataPage 企业数据--详情）
export function saveCachedViews(str) {
	if (useUserStore().cachedViews.indexOf(str) === -1) {
		useUserStore().cachedViews.push(str)
		// console.log(useUserStore().cachedViews, 'useUserStore().cachedViews')
	}
}

// 删除缓存页（EnterprisedetailsDataPage 企业数据--详情）
export function removeCachedViews(str, time) {
	// 只要离开当前页面 .5s后清除 页面缓存
	setTimeout(() => {
		let index = useUserStore().cachedViews.findIndex(val => {
			return val === str
		})

		if (index > -1) {
			useUserStore().cachedViews.splice(index, 1)
		}
		// console.log('remove useUserStore().cachedViews', useUserStore().cachedViews)
	}, time || 1000)
}

// 获取菜单权限 noDashboard时不跳转到首页
export function sysmenupowerPowerInApi(menuUrl, noDashboard) {
	return new Promise((resolve, reject) => {
		// console.log(menuUrl, 'menuUrl')
		sysmenupowerPowerIn({
			menuUrl: menuUrl || ''
		}).then(res => {
			if (res) {
				if (res.code === 4004) {
					setMessageQueue('error', res.msg)

					if (!noDashboard) {
						// 跳转首页并刷新
						router.push('/')
						// 调用公共方法 刷新必要接口数据 如首页-项目追踪/服务站/档案库、导航栏接口等
						useUserStore().isRefreshDashboard = true
						useUserStore().defaultOpeneds = ['0', '1', '2', '3', '4', '5']
						setTimeout(() => {
							useUserStore().isRefreshDashboard = false
						}, 200)
					}
				}
				// console.log(res, 'sysmenupowerPowerIn')
				resolve(res)
			}
		}).catch(error => {
			setMessageQueue('error', error)
			console.log(error, 'sysmenupowerPowerIn error')
			// reject(error)
			resolve(error)
		})
	})
}

// 更新缓存（确认已经缓存）
export function cacheUpdateCacheTypeApi(type) {
	cacheUpdateCacheType({
		type
	}).then(res => {
		if (res) {
			// console.log(res.data, 'cacheUpdateCacheTypeApi')
		}
	}).catch(error => {
		setMessageQueue('error', '更新异常-' + error)
		// reject(error)
		console.log(error, '更新缓存（确认已经缓存）')
	})
}

// 反馈状态 0待处理1已解决2已说明3无法解决
export function switchFeekStatus(status) {
	let str = ''
	switch (status) {
		case 0:
			str = '待处理'
			break
		case 1:
			str = '已解决'
			break
		case 2:
			str = '已说明'
			break
		case 3:
			str = '无法解决'
			break
	}

	return str
}

// 反馈状态 0待处理1已解决2已说明3无法解决
export function switchFeekStatusClass(status) {
	let str = ''
	switch (status) {
		case 0:
			str = 'back_FFC'
			break
		case 1:
			str = 'back_5FF'
			break
		case 2:
			str = 'back_4AD'
			break
		case 3:
			str = 'back_FF4'
			break
	}

	return str
}


// 转换背景class
export function switchFeedbackBackClass(val) {
	let str = ''
	switch (val) {
		case 0:
			str = 'DCLBackClass'
			break
		case 1:
			str = 'YJJBackClass'
			break
		case 2:
			str = 'YSMBackClass'
			break
		case 3:
			str = 'WFJJBackClass'
			break
	}
	console.log(str, val, 'switchFeedbackBackClass')
	return str
}

// 附件图片转换
export function switchFileIcon(status, theme) {
	let str = ''
	switch (status) {
		case '.txt':
			str = initThemeImg(theme, 'icon_wd_txt')
			break
		case '.pdf':
			str = initThemeImg(theme, 'icon_wd_pdf')
			break
		case '.ppt':
			str = initThemeImg(theme, 'icon_wd_ppt')
			break
		case '.pptx':
			str = initThemeImg(theme, 'icon_wd_ppt')
			break
		case '.doc':
			str = initThemeImg(theme, 'icon_wd_word')
			break
		case '.docx':
			str = initThemeImg(theme, 'icon_wd_word')
			break
		case '.xls':
			str = initThemeImg(theme, 'icon_wd_xlsx')
			break
		case '.xlsx':
			str = initThemeImg(theme, 'icon_wd_xlsx')
			break
		case '.zip':
			str = initThemeImg(theme, 'icon_wd_zip')
			break
		case '.rar':
			str = initThemeImg(theme, 'icon_wd_zip')
			break
		case '.gz':
			str = initThemeImg(theme, 'icon_wd_zip')
			break
		case '.bz2':
			str = initThemeImg(theme, 'icon_wd_zip')
			break
		case 'document':
			str = initThemeImg(theme, 'icon_wjj')
			break
		default:
			str = initThemeImg(theme, 'icon_wj@2x')
			break
	}
	return str
}

// 附件图片转换--缩略图
export function switchFileIconSec(status, theme) {
	let str = ''
	switch (status) {
		case '.txt':
			str = new URL('@/assets/imgs/common/txt.png', import.meta.url).href
			break
		case '.pdf':
			str = new URL('@/assets/imgs/common/pdf.png', import.meta.url).href
			break
		case '.ppt':
			str = new URL('@/assets/imgs/common/ppt.png', import.meta.url).href
			break
		case '.pptx':
			str = new URL('@/assets/imgs/common/ppt.png', import.meta.url).href
			break
		case '.doc':
			str = new URL('@/assets/imgs/common/doc.png', import.meta.url).href
			break
		case '.docx':
			str = new URL('@/assets/imgs/common/doc.png', import.meta.url).href
			break
		case '.xls':
			str = new URL('@/assets/imgs/common/xls.png', import.meta.url).href
			break
		case '.xlsx':
			str = new URL('@/assets/imgs/common/xls.png', import.meta.url).href
			break
		case '.zip':
			str = new URL('@/assets/imgs/common/zip.png', import.meta.url).href
			break
		case '.rar':
			str = new URL('@/assets/imgs/common/zip.png', import.meta.url).href
			break
		case '.gz':
			str = new URL('@/assets/imgs/common/zip.png', import.meta.url).href
			break
		case '.bz2':
			str = new URL('@/assets/imgs/common/zip.png', import.meta.url).href
			break
		case 'document':
			str = new URL('@/assets/imgs/common/wjj.png', import.meta.url).href
			break
		default:
			str = new URL('@/assets/imgs/common/wjj.png', import.meta.url).href
			break
	}
	return str
}

// 附件图片转换text
export function switchFileText(status, index) {
	if (status === 'txt' || status === 'pdf' || status === 'ppt' || status === 'pptx' || status === 'doc' ||
		status === 'docx' || status === 'xls' || status === 'xlsx' || status === 'zip' || status === 'rar' ||
		status === 'gz' || status === 'bz2' || status === 'jpeg' || status === 'png' || status === 'jpg' || status ===
		'gif' || status === 'mkv' || status === 'avi' || status === 'mov' || status === 'rmvb' || status === 'mp4' ||
		status === 'html' || status === 'js' || status === 'obj') {
		return '.' + status
	} else {
		// console.log(status, index, 'status, index')
		return index && status ? ('.' + status) : status
	}
}

// 20241125 新增 公共滚动方法 1、回到顶部：强制刷新时/搜索/创建模块/分页时；2、无需回到顶部：编辑模块/创建需求/编辑需求/编辑标题（需求/模块）/删除模块/删除需求时
// 20260116 修改 1、回到顶部： 2、无需回到顶部：创建模块/编辑模块/创建需求/编辑需求/编辑标题（需求/模块）/分页/删除模块/删除需求时
export function commonScrollToMethods(tableRef, type) {
	// type 强制刷新时/搜索/创建模块/分页
	if (tableRef && type) {
		tableRef.scrollTo(0, 0)
	}
}

// 判断是否是图片
export function isImageMethods(data) {
	let isImage = false

	// 20260116新增优化
	if (!data) {
		return isImage
	}

	let imgData = ['.bmp', '.gif', '.jpeg', '.png', '.jpg']
	for (let i = 0; i < imgData.length; i++) {
		if (data.indexOf(imgData[i]) > -1) {
			isImage = true
			return isImage
		}
	}
}

// 判断是否是video
export function isVideoMethods(data) {
	let isVideo = false
	let videoData = ['.rmvb', '.mp4', '.mov', '.avi', '.mkv']
	for (let i = 0; i < videoData.length; i++) {
		if (data.indexOf(videoData[i]) > -1) {
			isVideo = true
			return isVideo
		}
	}
}

// 根据文件类型不同 获取默认图片
export function getFileType(data) {
	if (data.indexOf('.txt') > -1) {
		return 'icon_text@2x'
	} else if (data.indexOf('.doc') > -1 || data.indexOf('.docx') > -1) {
		return 'icon_word@2x'
	} else if (data.indexOf('.ppt') > -1 || data.indexOf('.pptx') > -1) {
		return 'icon_ppt@2x'
	} else if (data.indexOf('.xls') > -1 || data.indexOf('.xlsx') > -1) {
		return 'icon_excel@2x'
	} else if (data.indexOf('.pdf') > -1) {
		return 'icon_file@2x'
	} else if (data.indexOf('.zip') > -1 || data.indexOf('.rar') > -1) {
		return 'icon_zip@2x'
	} else {
		return 'icon_file@2x'
	}
}

// 根据文件类型不同 获取默认背景色
export function getFileBack(data) {
	if (data.indexOf('.txt') > -1) {
		return 'txtBack'
	} else if (data.indexOf('.doc') > -1 || data.indexOf('.docx') > -1) {
		return 'docBack'
	} else if (data.indexOf('.ppt') > -1 || data.indexOf('.pptx') > -1) {
		return 'pptBack'
	} else if (data.indexOf('.xls') > -1 || data.indexOf('.xlsx') > -1) {
		return 'xlsBack'
	} else if (data.indexOf('.pdf') > -1) {
		return 'pdfBack'
	} else if (data.indexOf('.zip') > -1 || data.indexOf('.rar') > -1) {
		return 'zipBack'
	} else {
		return 'fileBack'
	}
}

// 根据文件类型不同 获取默认图片(项目附件)
export function getProFileType(data) {
	// console.log(data, 'data getProFileType')
	if (data.indexOf('.txt') > -1) {
		return 'icon_pro_text@2x'
	} else if (data.indexOf('.pdf') > -1) {
		return 'icon_pro_pdf@2x'
	} else if (data.indexOf('.doc') > -1 || data.indexOf('.docx') > -1) {
		return 'icon_pro_word@2x'
	} else if (data.indexOf('.ppt') > -1 || data.indexOf('.pptx') > -1) {
		return 'icon_pro_ppt@2x'
	} else if (data.indexOf('.xls') > -1 || data.indexOf('.xlsx') > -1) {
		return 'icon_pro_excel@2x'
	} else if (data.indexOf('.zip') > -1 || data.indexOf('.rar') > -1) {
		return 'icon_pro_zip@2x'
	} else if (data.indexOf('.rmvb') > -1 || data.indexOf('.mp4') > -1 || data.indexOf('.mov') > -1 || data.indexOf(
			'.avi') > -1 || data.indexOf('.mkv') > -1) {
		return 'icon_pro_video@2x'
	} else {
		return 'icon_pro_file@2x'
	}
}

// 根据文件类型不同 获取默认背景色(项目附件)
export function getProFileBack(data) {
	if (data.indexOf('.txt') > -1) {
		return 'txtProBack'
	} else if (data.indexOf('.pdf') > -1) {
		return 'pdfProBack'
	} else if (data.indexOf('.doc') > -1 || data.indexOf('.docx') > -1) {
		return 'docProBack'
	} else if (data.indexOf('.ppt') > -1 || data.indexOf('.pptx') > -1) {
		return 'pptProBack'
	} else if (data.indexOf('.xls') > -1 || data.indexOf('.xlsx') > -1) {
		return 'xlsProBack'
	} else if (data.indexOf('.zip') > -1 || data.indexOf('.rar') > -1) {
		return 'zipProBack'
	} else if (data.indexOf('.rmvb') > -1 || data.indexOf('.mp4') > -1 || data.indexOf('.mov') > -1 || data.indexOf(
			'.avi') > -1 || data.indexOf('.mkv') > -1) {
		return 'videoProBack'
	} else {
		return 'fileProBack'
	}
}

// 附件提醒弹窗-附件图片转换
export function getTipsFileIcon(theme, data) {
	console.log(data, 'data getTipsFileIcon')
	if (data.indexOf('.txt') > -1) {
		return initThemeImg(theme, 'icon_tips_text@2x')
	} else if (data.indexOf('.pdf') > -1) {
		return initThemeImg(theme, 'icon_tips_pdf@2x')
	} else if (data.indexOf('.doc') > -1) {
		return initThemeImg(theme, 'icon_tips_doc@2x')
	} else if (data.indexOf('.docx') > -1) {
		return initThemeImg(theme, 'icon_tips_docx@2x')
	} else if (data.indexOf('.ppt') > -1) {
		return initThemeImg(theme, 'icon_tips_ppt@2x')
	} else if (data.indexOf('.pptx') > -1) {
		return initThemeImg(theme, 'icon_tips_pptx@2x')
	} else if (data.indexOf('.xls') > -1) {
		return initThemeImg(theme, 'icon_tips_xls@2x')
	} else if (data.indexOf('.xlsx') > -1) {
		return initThemeImg(theme, 'icon_tips_xlsx@2x')
	} else if (data.indexOf('.zip') > -1) {
		return initThemeImg(theme, 'icon_tips_zip@2x')
	} else if (data.indexOf('.rar') > -1) {
		return initThemeImg(theme, 'icon_tips_rar@2x')
	} else if (data.indexOf('.rmvb') > -1 || data.indexOf('.mp4') > -1 || data.indexOf('.mov') > -1 || data.indexOf(
			'.avi') > -1 || data.indexOf('.mkv') > -1 || data.indexOf('.MOV') > -1) {
		return initThemeImg(theme, 'icon_tips_video@2x')
	} else {
		return initThemeImg(theme, 'icon_tips_file@2x')
	}
}

// 通用单独下载 二进制下载流（后端为application/octet-stream）
export function fileDownloadFileApi(fileId, moduleName, functionName) {
	fileDownloadFile({
		fileId,
		moduleName,
		functionName
	}).then(res => {
		if (res) {
			// console.log(res, 'resresresres')
			// 下载公共方法
			fileDownloadFileMethods()
		}
	}).catch(e => {
		setMessageQueue('error', e)
		console.log(e)
	})
}

// 下载公共方法
export function fileDownloadFileMethods(res) {
	const headers = res.headers;
	const contentType = headers['content-type'];
	const contentDisposition = headers['content-disposition'];
	const fileName = contentDisposition.split('.')[0]; // 从响应头中提取文件名

	const blob = new Blob([res.data], {
		type: contentType
	});
	const url = window.URL.createObjectURL(blob);

	const link = document.createElement('a');
	link.href = url;
	link.download = !isNaN(fileName) ? headers['content-disposition'] : decodeURI(headers[
		'content-disposition']);; // 设置下载文件的名称
	link.click();
	window.URL.revokeObjectURL(url); // 释放 URL 对象
}

// 获取remark文字
export function getRemark(val) {
	let str = ''
	switch (val) {
		case '0':
			str = '前面'
			break;
		case '1':
			str = '后面'
			break;
		case '2':
			str = '左面'
			break;
		case '3':
			str = '右面'
			break;
		case '4':
			str = '顶部'
			break;
		case '5':
			str = '底部'
			break;
		default:
			break;
	}
	return str
}

// 根据自定义配置--阅读模式 来跳转页面  parUrl为一级菜单路由路径
export function jumpUrlConfig(routerUrl, parUrl, params) {
	window.open(window.location.origin + routerUrl + (params ? params : '&') + 'isParentUrl=' + encodeURIComponent(
		parUrl), '_blank')
}

// 获取当前路由路径
export function getPathName() {
	return window.location.pathname.replace('/', '')
}

const pathAllData = ref([{
	parentPath: 'equipmentRegistration',
	children: ['equipmentRegistrationDetails', 'addEquipmentPage']
}, {
	parentPath: 'generalArchive',
	children: ['generalArchiveCreateFile']
}, {
	parentPath: 'enterpriseDataPage',
	children: ['enterprisedetailsDataPage', 'addMembers', 'enterpriseDataEdit', 'enterpriseJoinPage']
}, {
	parentPath: 'memberAccount',
	children: ['memberAccountAdd']
}, {
	parentPath: 'serviceStation',
	children: ['serviceStationDetails']
}, {
	parentPath: 'projectCenter',
	children: ['moduleAndRequirementCreateAndEditAndDetails', 'projectCreateAndIntroduceAndEdit']
}, {
	parentPath: 'bulletinPage',
	children: ['bulletinDetailsPage']
}, {
	parentPath: 'mailPage',
	children: ['mailDetailsPage']
}, {
	parentPath: 'noticePage',
	children: ['noticeDetailsPage']
}, {
	parentPath: 'taskCenter',
	children: ['taskCenterIntroduce', 'taskCenterShowAll']
}, {
	parentPath: 'taskConfiguration',
	children: ['taskConfigurationAddAndEditTemplate']
}, {
	parentPath: 'equipmentApproval',
	children: ['equipmentApprovalDetails']
}, {
	parentPath: 'archiveSetting',
	children: ['warningContent']
}, {
	parentPath: 'pathInformation',
	children: ['pathInformationEdit']
}, {
	parentPath: 'incomeAndExpenditureDetails',
	children: ['incomeAndExpenditureDetailsToDetails', 'incomeAndExpenditureDetailsToDetails']
}, {
	parentPath: 'productDescriptionGenerator',
	children: ['productDescriptionGeneratorAddAndEdit']
}, {
	parentPath: 'updateNotesGenerator',
	children: ['updateNotesGeneratorAddAndEditDocument', 'updateNotesGeneratorAddAndEditLogs']
}, {
	parentPath: 'projectDashboard',
	children: ['projectLeaderRankingList', 'projectLeaderRankingDetails', 'moduleCreateRankingList',
		'moduleCreateRankingDetails', , 'moduleChargeRankingList', 'moduleChargeRankingDetails',
		'moduleFinishRankingList', 'moduleFinishRankingDetails', 'requirementCreateRankingList',
		'requirementCreateRankingDetails', 'requirementHandlerRankingList',
		'requirementHandlerRankingDetails', 'requirementFinishRankingList',
		'requirementFinishRankingDetails', 'requirementAssistantRankingList',
		'requirementAssistantRankingDetails', 'requirementInspectorRankingList',
		'requirementInspectorRankingDetails', 'yearOnYearComparison', 'moduleChargeDetails',
		'moduleCreateDetails', 'moduleFinishDetails', 'moduleInspectionDetails',
		'requirementCreateDetails', 'requirementFinishAssistDetails', 'requirementFinishDetails',
		'requirementHandleAssistDetails', 'requirementHandleDetails', 'requirementInspectionDetails'
	]
}]) // 所有父子级关系数据

// , {
// 	parentPath: 'memberArchive',
// 	children: ['', '', '']
// }
// , {
// 	parentPath: 'groupConfiguration',
// 	children: ['', '', '']
// }

// 通过传子级获取父级路径
export function getParentPathName(childPath) {
	let parentPath = ''
	pathAllData.value.map((item, index) => {
		if (item.children.length > 0) {
			item.children.map(items => {
				if ((childPath || getPathName()) === items) {
					parentPath = item.parentPath
				}
			})
		}
	})
	return parentPath
}

// 20260423 新增根据菜单查对应权限功能 特殊页面 获取父级菜单
// 材料详情materialsDetails 材料编辑materialsEdit 新建/追加材料memberArchiveNewMaterials 变更日志详情changeLogsDetails 反馈详情feedbackDetails 
// 模块需求详情moduleAndRequirementCreateAndEditAndDetails 发布公告pushBulletinPage 发布站内信pushMailPage 发布通告pushNoticePage 成员信息详情memberAccountEdit
// 发布任务taskAddAndEdit
export function getFilterUrl(path, pageType, typeVal, queryPath, queryId) {
	let str = ''

	if (path === '/materialsEdit' || path === '/memberArchiveNewMaterials' || path === '/materialsDetails') {
		if (pageType === 'accountMess') {
			str = 'accountMessPage'
		} else {
			if (typeVal === 'general') {
				str = 'generalArchive'
			} else if (typeVal === 'member') {
				str = 'memberArchive'
			} else {
				str = 'expirationWarning'
			}
		}
	} else if (path === '/changeLogsDetails') {
		if (pageType === 'enterprisedetailsDataPage') {
			str = 'enterpriseDataPage'
		} else {
			str = 'changeLogs'
		}
	} else if (path === '/feedbackDetails') {
		if (pageType === 'myFeedback') {
			str = 'myFeedback'
		} else {
			str = 'collectFeedbackPage'
		}
	} else if (path === '/moduleAndRequirementCreateAndEditAndDetails') {
		str = queryPath ? queryPath.replace('/', '') : getParentPathName(path)
	} else if (path === '/pushBulletinPage') {
		if (pageType) {
			str = 'noticeSetting'
		} else {
			str = 'bulletinPage'
		}
	} else if (path === '/pushMailPage') {
		if (pageType) {
			str = 'noticeSetting'
		} else {
			str = 'mailPage'
		}
	} else if (path === '/pushNoticePage') {
		if (pageType === 'noticeSetting') {
			str = 'noticeSetting'
		} else {
			str = 'noticePage'
		}
	} else if (path === '/taskAddAndEdit') {
		if (queryId) {
			str = 'taskQueue'
		} else {
			str = 'taskCenter'
		}
	} else if (path === '/memberAccountEdit') {
		if (pageType === 'enterprisedetailsDataPage' || pageType === 'enterpriseDataPage') {
			str = 'enterpriseDataPage'
		} else {
			str = 'memberAccount'
		}
	} else if (path === '/xqFinancialFeedbackDetails') {
		str = pageType
	}

	console.log(str ? '/' + str : '', 'getFilterUrlgetFilterUrl')

	return str ? '/' + str : ''

}

// 公共返回方法 20260409 新增 复制链接的保存（模块/需求详情 项目介绍） 保存后需要跳转至项目中心页（删除项目中心缓存）
export function goBackCommonHandle(step, cacheObj, projectId) {
	const local = window.location
	const search = local.search
	const pathname = local.pathname
	let url = search.split('isParentUrl=')[1]
	let num = 0

	// 有缓存时 删除对应缓存数据
	if (cacheObj) {
		console.log(cacheObj.cacheType, cacheObj.level, 'cacheObj.cacheType, cacheObj.level')
		// alert(222)
		// 20260409 新增 复制链接的保存 保存后需要跳转至项目中心页（有projectId 代表可以删项目中心缓存--模块/需求详情 项目介绍）
		if (projectId) {
			// 项目追踪--模块/需求详情 项目介绍 点击返回--删除项目追踪所有缓存
			globalCacheDeleteApi('project_centre', 0)
		} else {
			globalCacheDeleteApi(cacheObj.cacheType, cacheObj.level)
		}
	} else {
		// console.log(step, pathname, 'step pathname')
		if (pathname.includes('/moduleAndRequirementCreateAndEditAndDetails')) {
			// alert(333)
			// 项目追踪--模块详情--创建需求时 点击返回--删除项目追踪所有缓存
			globalCacheDeleteApi('project_centre', 0)
		}
	}

	// 有step时 为删除材料 => 需向上返回两步
	if (step) {
		if (url) {
			router.push('/memberArchive')
		} else {
			router.go(-2)
		}
	} else {
		if (url) {
			router.push('/' + url)
			// router.push('/' + decodeURIComponent(url))
		} else {
			// 20260409 新增 复制链接的保存 保存后需要跳转至项目中心页（删除项目中心缓存）
			if (projectId) {
				localStorage.setItem('projectIdIsCopy', projectId)
				router.push('/projectCenter')
			} else {
				num++
				// 防止重复返回
				// alert(num)
				if (num === 1) {
					// alert(11)
					// 20260415 新增 直接复制某个链接（非项目追踪复制链接部分）期望点击返回回到首页（直接替换旧路由地址）
					// 检查浏览器历史记录中是否存在上一个状态
					// history.state 是由 Vue Router 维护的，其中包含 'back' 等信息
					if (window.history.state && window.history.state.back) {
						router.back(); // 如果有，则返回上一页
					} else {
						// 如果没有，则跳转到指定页面，比如首页 '/'
						// 使用 replace 避免在历史记录中留下过多痕迹
						router.replace({
							path: '/'
						});
					}
				}
			}
		}
	}
	// console.log(url, cacheObj, 'routeroute')

}

// 自定义主题色色值
export function initCustomTheme(theme) {
	return [{
		spotBack: '#D9D9D9',
		colour: '#B9B9B9',
		backgroundColour: 'rgba(255, 255, 255, 0)',
		borderColour: '#343737',
		img: initThemeImg(theme, 'icon-D9D@2x'),
	}, {
		spotBack: '#F5FFB4',
		colour: '#F5FFB4',
		backgroundColour: 'rgba(245,255,180,0.1)',
		borderColour: '#F5FFB4',
		img: initThemeImg(theme, 'icon-F5F@2x'),
	}, {
		spotBack: '#FFEC7E',
		colour: '#FFEC7E',
		backgroundColour: 'rgba(255,236,126,0.1)',
		borderColour: '#FFEC7E',
		img: initThemeImg(theme, 'icon-FFE@2x'),
	}, {
		spotBack: '#FFC77E',
		colour: '#FFC77E',
		backgroundColour: 'rgba(255,199,126,0.1)',
		borderColour: '#FFC77E',
		img: initThemeImg(theme, 'icon-FFC@2x'),
	}, {
		spotBack: '#FFB97E',
		colour: '#FFA947',
		backgroundColour: 'rgba(255,185,126,0.1)',
		borderColour: '#FFA947',
		img: initThemeImg(theme, 'icon-FFB@2x'),
	}, {
		spotBack: '#FF6146',
		colour: '#FF6146',
		backgroundColour: 'rgba(255,97,70,0.1)',
		borderColour: '#FF6146',
		img: initThemeImg(theme, 'icon-FF6@2x'),
	}, {
		spotBack: '#FF857E',
		colour: '#FF857E',
		backgroundColour: 'rgba(255,133,126,0.1)',
		borderColour: '#FF857E',
		img: initThemeImg(theme, 'icon-FF8@2x'),
	}, {
		spotBack: '#FF4444',
		colour: '#FF4444',
		backgroundColour: 'rgba(255,68,68,0.1)',
		borderColour: '#FF4444',
		img: initThemeImg(theme, 'icon-FF4@2x'),
	}, {
		spotBack: '#FF4B6F',
		colour: '#FF4B6F',
		backgroundColour: 'rgba(255,75,111,0.1)',
		borderColour: '#FF4B6F',
		img: initThemeImg(theme, 'icon-FF4B@2x'),
	}, {
		spotBack: '#FFBFB4',
		colour: '#FFBFB4',
		backgroundColour: 'rgba(255,191,180,0.1)',
		borderColour: '#FFBFB4',
		img: initThemeImg(theme, 'icon-FFBF@2x'),
	}, {
		spotBack: '#FF7EBC',
		colour: '#FF7EBC',
		backgroundColour: 'rgba(255,126,188,0.1)',
		borderColour: '#FF7EBC',
		img: initThemeImg(theme, 'icon-FF7@2x'),
	}, {
		spotBack: '#E3FF7E',
		colour: '#E3FF7E',
		backgroundColour: 'rgba(227,255,126,0.1)',
		borderColour: '#E3FF7E',
		img: initThemeImg(theme, 'icon-E3F@2x'),
	}, {
		spotBack: '#85D03A',
		colour: '#A9FF7E',
		backgroundColour: 'rgba(169,255,126,0.1)',
		borderColour: '#A9FF7E',
		img: initThemeImg(theme, 'icon-85D@2x'),
	}, {
		spotBack: '#7EFF8D',
		colour: '#7EFF8D',
		backgroundColour: 'rgba(126,255,141,0.1)',
		borderColour: '#7EFF8D',
		img: initThemeImg(theme, 'icon-7EF@2x'),
	}, {
		spotBack: '#7EFFD5',
		colour: '#7EFFD5',
		backgroundColour: 'rgba(126,255,213,0.1)',
		borderColour: '#7EFFD5',
		img: initThemeImg(theme, 'icon-7EFF@2x'),
	}, {
		spotBack: '#1FD3B0',
		colour: '#1FD3B0',
		backgroundColour: 'rgba(31,211,176,0.1)',
		borderColour: '#1FD3B0',
		img: initThemeImg(theme, 'icon-1FD@2x'),
	}, {
		spotBack: '#7EFFF5',
		colour: '#7EFFF5',
		backgroundColour: 'rgba(126,255,245,0.1)',
		borderColour: '#7EFFF5',
		img: initThemeImg(theme, 'icon-7EFFF@2x'),
	}, {
		spotBack: '#7ED6FF',
		colour: '#7ED6FF',
		backgroundColour: 'rgba(126,214,255,0.1)',
		borderColour: '#7ED6FF',
		img: initThemeImg(theme, 'icon-7ED@2x'),
	}, {
		spotBack: '#7EB0FF',
		colour: '#7EB0FF',
		backgroundColour: 'rgba(126,176,255,0.1)',
		borderColour: '#7EB0FF',
		img: initThemeImg(theme, 'icon-7EB@2x'),
	}, {
		spotBack: '#837EFF',
		colour: '#837EFF',
		backgroundColour: 'rgba(131,126,255,0.1)',
		borderColour: '#837EFF',
		img: initThemeImg(theme, 'icon-837@2x'),
	}, {
		spotBack: '#BB7EFF',
		colour: '#BB7EFF',
		backgroundColour: 'rgba(187,126,255,0.1)',
		borderColour: '#BB7EFF',
		img: initThemeImg(theme, 'icon-BB7@2x'),
	}, {
		spotBack: '#FF7EF6',
		colour: '#FF7EF6',
		backgroundColour: 'rgba(255,126,246,0.1)',
		borderColour: '#FF7EF6',
		img: initThemeImg(theme, 'icon-FF7E@2x'),
	}]
}

// // 获取按钮不可编辑状态及提示  非管理员--权限不足/项目锁定/项目阶段--已结束
// export function getNotEditableShow(isPermission, stageName, projectLockText) {
// 	if (isPermission && !isGetPermission()) {
// 		setMessageQueue('warning', '权限组不满足，无法操作')
// 		return true
// 	} else if (projectLockText) {
// 		// 获取项目配置 项目锁定
// 		if (projectConfigData.value.projectLock === 1) {
// 			setMessageQueue('warning', '无法' + (projectLockText || '编辑') + '，项目追踪-项目锁定已开启')
// 			return true
// 		}
// 	} else if (stageName === '已结束') {
// 		setMessageQueue('info', '当前项目' + stageName)
// 		return true
// 	}
// }

// 保存详情页路径缓存
export function globalCacheSaveApi(cacheObj) {
	// member_info 成员信息/change_log 变更日志/member_archive 成员档案/overall_archive 综合档案--最多两级/device_log 设备登记--最多两级
	// device_approve 设备审批/project_my_create 我的创建/project_my_todo 我的待办/project_centre 项目中心--最多两级/service_station 服务站

	// redirectPath, // 前端跳转路径
	// cacheType, // 缓存类型
	// level, // 缓存层级（0:全部, 1:一级, 2:二级）
	// queryType, // 项目追踪部分模块（module）、需求（requirement） 综合档案区分档案（archival）、材料（material）
	// queryId // 查询时需要验证的数据id是否存在
	let params = {
		...cacheObj
	}
	params.token = localStorage.getItem('token')
	// return new Promise((resolve, reject) => {
	globalCacheSave(params).then(res => {
		if (res) {
			// console.log(res, 'globalCacheSave')
			// resolve(res)
		}
	}).catch(error => {
		console.log(error, 'globalCacheSave error')
		setMessageQueue('error', '保存异常-' + error)
		// reject(error)
	})
	// })
}

// 查询详情页路径缓存
export function globalCacheQueryApi(cacheType) {
	// 成员信息/变更日志/成员/综合档案--最多两级/设备登记--最多两级/设备审批/我的创建/我的待办/项目中心--最多两级
	return new Promise((resolve, reject) => {
		globalCacheQuery({
			cacheType, // 缓存类型
			token: localStorage.getItem('token') || ''
		}).then(res => {
			if (res) {
				// console.log(res, 'globalCacheQuery')
				resolve(res)
			}
		}).catch(error => {
			setMessageQueue('error', '查询异常-' + error)
			console.log(error, 'globalCacheQuery error')
			// reject(error)
		})
	})
}

// 设置当前所在位置(点击菜单时删除对应的详情路径缓存数据)
export function globalCacheSaveWhereNowApi(location, parentLocation) {
	// 成员信息/变更日志/成员/综合档案/到期预警/设备登记/设备审批/我的创建/我的待办/待协助项/项目中心（暂无成员信息memberAccountEdit）
	return new Promise((resolve, reject) => {
		// 变更日志changeLogsDetails  成员/综合档案/到期预警memberArchiveNewMaterials/materialsEdit/materialsDetails
		// 我的创建/我的待办/待协助项/项目中心-需求moduleAndRequirementCreateAndEditAndDetails  添加设备addEquipmentPage
		// 项目中心-项目介绍projectCreateAndIntroduceAndEdit  新桥金融反馈详情xqFinancialFeedbackDetails
		const parentLocationData = parentLocation ? parentLocation.replace('/', '') : window.location.pathname
			.replace('/', '')
		console.log(parentLocationData, 'parentLocationData')

		globalCacheSaveWhereNow({
			location, // 当前页面位置
			token: localStorage.getItem('token') || '',
			parentLocation: parentLocationData
		}).then(res => {
			if (res) {
				// console.log(res, 'globalCacheSaveWhereNow')
				resolve(res)
			}
		}).catch(error => {
			setMessageQueue('error', '保存异常-' + error)
			console.log(error, 'globalCacheSaveWhereNow error')
			// reject(error)
		})
	})
}

const deleteDisabled = ref(false) // 禁用重复调用

// 删除详情页路径缓存
export function globalCacheDeleteApi(cacheType, level) {
	if (deleteDisabled.value) {
		return
	}

	// 成员信息/变更日志/成员/综合档案--最多两级/设备登记--最多两级/设备审批/我的创建/我的待办/项目中心--最多两级
	// return new Promise((resolve, reject) => {
	globalCacheDelete({
		cacheType, // 缓存类型
		level, // 缓存层级（0:全部, 1:一级, 2:二级）
		token: localStorage.getItem('token') || ''
	}).then(res => {
		if (res) {
			deleteDisabled.value = false
			// console.log(res, 'globalCacheDelete')
			// resolve(res)
		}
	}).catch(error => {
		deleteDisabled.value = false
		setMessageQueue('error', '删除异常-' + error)
		console.log(error, 'globalCacheDelete error')
		// reject(error)
	})
	// })
}

// 503无权限时 缓存菜单类型
function globalCacheDeleteNoPermissionSwitch(val) {
	let str = ''

	switch (val) {
		// 成员信息
		case 'memberAccount':
			str = 'member_info'
			break;
			// 变更日志
		case 'changeLogs':
			str = 'change_log'
			break;
			// 成员档案
		case 'memberArchive':
			str = 'member_archive'
			break;
			// 综合档案
		case 'generalArchive':
			str = 'overall_archive'
			break;
			// 到期预警
		case 'expirationWarning':
			str = 'waring_archive'
			break;
			// 设备登记
		case 'equipmentRegistration':
			str = 'device_log'
			break;
			// 设备审批
		case 'equipmentApproval':
			str = 'device_approve'
			break;
			// 我的创建
		case 'myCreate':
			str = 'project_my_create'
			break;
			// 待协助项
		case 'itemsRequiringAssistance':
			str = 'project_my_assist'
			break;
			// 我的待办
		case 'myToDo':
			str = 'project_my_todo'
			break;
			// 项目中心
		case 'projectCenter':
			str = 'project_centre'
			break;
			// 服务站
		case 'serviceStation':
			str = 'service_station'
			break;
	}

	return str
}

// 503无权限时 时删除对应菜单下所有路径缓存 延时300ms
export function globalCacheDeleteNoPermissionApi(cacheType) {
	setTimeout(() => {
		// 成员信息/变更日志/成员/综合档案--最多两级/到期预警/设备登记--最多两级/设备审批/我的创建/待协助项/我的待办/项目中心--最多两级/服务站
		globalCacheDelete({
			cacheType: globalCacheDeleteNoPermissionSwitch(cacheType), // 缓存类型
			level: 0, // 缓存层级（0:全部, 1:一级, 2:二级）
			token: localStorage.getItem('token') || ''
		}).then(res => {
			if (res) {
				console.log(res, 'globalCacheDelete')
			}
		}).catch(error => {
			setMessageQueue('error', '页面缓存删除异常-' + error)
			console.log(error, 'globalCacheDelete error')
		})
	}, 300)
}

function randomStr(minLen = 5, maxLen = 6) {
	const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
	const numbers = '0123456789';
	const allChars = letters + numbers;

	// 随机长度
	const len = Math.floor(Math.random() * (maxLen - minLen + 1)) + minLen;

	// 必须包含至少一个字母和一个数字，因此至少需要两位
	if (len < 2) throw new Error('长度至少为2才能同时包含字母和数字');

	// 随机放置字母和数字的位置
	let result = new Array(len);
	// 随机选择一个位置放字母
	const letterPos = Math.floor(Math.random() * len);
	// 随机选择一个不同于 letterPos 的位置放数字
	let numberPos = Math.floor(Math.random() * len);
	while (numberPos === letterPos) {
		numberPos = Math.floor(Math.random() * len);
	}

	result[letterPos] = letters.charAt(Math.floor(Math.random() * letters.length));
	result[numberPos] = numbers.charAt(Math.floor(Math.random() * numbers.length));

	// 填充剩余位置
	for (let i = 0; i < len; i++) {
		if (i !== letterPos && i !== numberPos) {
			result[i] = allChars.charAt(Math.floor(Math.random() * allChars.length));
		}
	}

	return result.join('');
}

// 分享前检测需求、模块、项目是否存在
export function getCheckShare(id, type) {
	return new Promise((resolve, reject) => {
		projecttrackingrequirementCheckShare({
			id, // 需求、模块或项目ID
			type // requirement：需求、module：模块、project：项目
		}).then(res => {
			if (res) {
				let msg = res.msg

				if (res.code === 505) {
					setMessageQueue('warning', msg)
				}

				// console.log(res, 'projecttrackingrequirementCheckShare')
				resolve(res)
			}
		}).catch(error => {
			console.log(error, 'projecttrackingrequirementCheckShare error')
			reject(error)
		})
	})
}

// 检查成员档案是否被删除
export function getCheckUserArchive(id) {
	return new Promise((resolve, reject) => {
		archiverecordCheckUserArchive({
			id // 对应用户id
		}).then(res => {
			if (res) {
				let msg = res.msg

				if (res.code === 505) {
					setMessageQueue('warning', msg)
				}

				// console.log(res, 'archiverecordCheckUserArchive')
				resolve(res)
			}
		}).catch(error => {
			console.log(error, 'archiverecordCheckUserArchive error')
			reject(error)
		})
	})
}

// 检查用户是否不存在
export function getCheckUserExist(id) {
	return new Promise((resolve, reject) => {
		sysuserCheckUserExist({
			id // 对应用户id
		}).then(res => {
			if (res) {
				let msg = res.msg

				if (res.code === 505) {
					setMessageQueue('warning', msg)
				}

				// console.log(res, 'sysuserCheckUserExist')
				resolve(res)
			}
		}).catch(error => {
			console.log(error, 'sysuserCheckUserExist error')
			reject(error)
		})
	})
}

// 获取按钮不可编辑状态提示  非管理员--权限不足/项目锁定/项目阶段--已结束 20250520--此方法做改动 获取接口实时返回的权限及提示语  项目追踪详情时不给提示noTips
export function getNotEditableShow(projectId, projectLockText, type, noTips, ids, cancelText, mark, envTime, check,
	checkType, checkTypeId) {
	// 获取权限错误提示 非管理员/项目--锁定/已结束
	// 类型type：1权限，2项目(同时判断锁定、结束)，3定制路径，4成员档案导出许可，5综合档案导出许可，6到期预警导出许可，7设备登记导出许可，8设备审批导出许可
	// 9成员综合档案（包括材料）的删除，10设备的删除，11成员综合档案的编辑；设备申请按钮；设备审批按钮 12综合档案成员锁定 13档案可见锁定许可 14任务队列锁定许可 15企业数据变更许可
	// 项目ID 当type为2/3/4/5时必须传值
	// action动作，1创建 2删除 3编辑（projectLockText） type为11时传参（申请/审批/编辑）
	// from 要移除/注销的用户（ids）
	// mark 项目详情部分 传值endProject 其他的不用改动
	// envTime 环境，如果需要验证是否体验环境，传值当前时间戳  如果不需要验证，则传空即可  注：只要有值后端就会提供环境 20260323新增
	// check 1时传参随机5-6位字符串字母+数字 2时传特定值为安全设置-二维码部分使用 ，我就会跳过powerAbout接口后续验证，只进行环境验证； 如果无值，会根据envTime进行判断，后续权限也会正常验证 20260323新增 
	// checkType 校验类型 STATION_LETTER站内信  NOTICE 公告  ORGANIZE 组织  PUBLICITY_UPDATE 公示-更新  PUBLICITY_DELETE 公示-删除  20260323新增
	// checkTypeId 校验类型对应的ID数值，仅存在checkType有值的时候，务必保证二者同时有值 20260323新增
	return new Promise((resolve, reject) => {
		projecttrackingprojectPowerAbout({
			type: type || type === 0 ? type : 2,
			projectId,
			action: projectLockText || (projectId ? '编辑' : ''),
			from: ids || null, // 要移除/注销的用户
			mark: mark || null,
			envTime: envTime === 1 ? new Date().getTime() : null,
			check: check === 1 ? randomStr() : (check === 2 ? 'WeChatAuth' : null),
			checkType: checkType || null,
			checkTypeId: checkTypeId || null
		}).then(res => {
			if (res) {
				let msg = res.msg

				if (res.code === 505) {
					if (!noTips) {
						if (msg.includes('无法移除') && cancelText) {
							setMessageQueue('warning', msg.replace(/移除/g, cancelText))
						} else {
							setMessageQueue('warning', msg)
						}
					} else {
						if (msg.includes('无法访问') || msg.includes('不存在')) {
							setMessageQueue('warning', msg)
						} else {
							setMessageQueue('warning', msg)
						}
					}
				}

				// console.log(res, 'projecttrackingprojectPowerAboutApi')
				resolve(res)
			}
		}).catch(error => {
			console.log(error, 'projecttrackingprojectPowerAboutApi error')
			reject(error)
		})
	})
}

// 注销/移除成员前置接口
export function sysuserCancelRemovePrecheckApi(from, ids, action) {
	// 获取权限错误提示 非管理员
	// 许可/至少保留一个主账号!/不能删除自己账号
	// 当前为唯一主账号时校验
	// 企业运维可以删除/注销 主账号/运维账号  集团账号不可以
	return new Promise((resolve, reject) => {
		sysuserCancelRemovePrecheck({
			from, // 来源：集团账号：company、运维中心：service
			action, // 动作，1移除，2注销
			ids: ids || null // 要移除/注销的用户
		}).then(res => {
			if (res) {
				let msg = res.msg
				if (res.code === 505) {
					setMessageQueue('warning', msg)
				}
				// console.log(res, 'sysuserCancelRemovePrecheckApi')
				resolve(res)
			}
		}).catch(error => {
			console.log(error, 'sysuserCancelRemovePrecheckApi error')
			reject(error)
		})
	})
}

// 获取动态左侧菜单+标题
export function getLeftMenuList(menuUrl) {
	return new Promise((resolve, reject) => {
		sysmenuMenuList({
			menuUrl
		}).then(res => {
			if (res) {
				// console.log(res, 'sysmenuMenuList')
				resolve(res)
			}
		}).catch(error => {
			console.log(error, 'sysmenuMenuList error')
			reject(error)
		})
	})
}

// 获取按钮不可编辑 样式(非管理员+用户--权限不足/项目锁定/项目阶段--已结束) 20250520--此方法不用改 只需获取初始化接口时 最新数据即可 20260420--新增项目中心-创建模块未参与校验
export function getNotEditableShowClass(isPermission, stageName, projectLockText, isNoJoin) {
	// console.log(projectLockText, projectConfigData.value.projectLock === 1, 'getNotEditableShowClass')
	if ((isPermission && !isGetPermissionAndUser()) || (projectLockText && projectConfigData.value.projectLock === 1) ||
		(
			stageName === '已结束') || isNoJoin) {
		return ' opacity05'
	} else {
		return ''
	}
}

// 获取禁用/不显示 (非管理员+用户--权限不足/项目锁定/项目阶段--已结束) 20250520--此方法不用改 只需获取初始化接口时 最新数据即可
export function getNotEditableShowDisabled(isPermission, stageName, projectLockText) {
	// console.log(isPermission, isGetPermission(), isPermission && !isGetPermissionAndUser(), 'getNotEditableShowDisabled')
	if ((isPermission && !isGetPermissionAndUser()) || (projectLockText && projectConfigData.value.projectLock === 1) ||
		(
			stageName === '已结束')) {
		return true
	}
}

// 获取最新是否开始二级密码保护
export function getConfigusersafeInfo() {
	if (localStorage.getItem('token')) {
		// 获取用户信息
		useUserStore().configusersafeInfoApi()
	}
}

// 获取是否是图片
export function getIsImg(originalName) {
	let imgData = ['.bmp', '.gif', '.jpeg', '.png', '.jpg']
	for (let i = 0; i < imgData.length; i++) {
		if (originalName.indexOf(imgData[i]) > -1) {
			return true
		}
	}
}

// 编辑权限（20260512 新增 管理员）
export function isGetPermission() {
	let role = false
	const info = userInfo.value

	if (info.role === 'admin') {
		role = true
	}

	return role
}

// 编辑权限（20260512 新增 管理员+用户）
export function isGetPermissionAndUser() {
	let role = false
	const info = userInfo.value

	if (info.role === 'admin' || info.role === 'user') {
		role = true
	}

	return role
}

// 当前登录人编辑权限
export function isGetCurrentUserPermission(user) {
	let role = false
	if (userInfo.value.id === user) {
		role = true
	}
	return role
}

// 初始化当前主题色
export function initTheme(theme) {
	// console.log(theme, 'theme initTheme')
	window.document.documentElement.setAttribute('data-theme', theme)
}

// 根据当前主题色获取图片路径
export function initThemeImg(theme, img, suffix) {
	return new URL(`../assets/imgs/${theme}/${img}.${suffix || 'png'}`, import.meta.url).href
}

// 根据路由判断当前是否现实拼色导航展开收起样式
export function getIsMixed(path) {
	// console.log(path, 'path getIsMixed')
	if (path === '/updateNotesGeneratorAddAndEditLogs' || path === '/productDescriptionGeneratorAddAndEdit') {
		return true
	}

	return false
}

// 进入去登录页
export function goLogin(params, go) {
	// go => 401 20241212 新增401相关判断 
	let jumpLink = defaultSettings.systemLink
	if (jumpLink) {
		window.location.href = defaultSettings.ssoLink + '?href=' + jumpLink + (params ? params :
			('&hrefPage=' + defaultSettings.hrefPage + '&isLogout=' + (localStorage.getItem('isLogout') || '') +
				'&fourZOne=' + (go || '') + '&noJump='))
		// 20251105新增 点击请先登录 清除所有缓存
		localStorage.clear();
		return
	}
}

// 重置登录状态
export function resetLogin(type, tips, go) {
	// console.log(type, tips, go, 'type, tips, go')
	if (type === 'logout') {
		logout({
			businessName: 'tracking',
			userId: useUserStore().userInfo.id,
			ticket: localStorage.getItem('ticket') || '', // 20241204 新增 取当前系统的ticket缓存 区分不同平台的退出登录
			secret: 'true' // 同一账号同一平台不同浏览器登录： true按平台单独退出登录  ''按平台统一退出登录
		}).then(res => {
			if (res) {
				// 20241121 新增 缓存当前退出的账号
				localStorage.setItem('logoutAccount', useUserStore().userInfo.username)
				// 20241204 新增 点击过退出登录标识
				localStorage.setItem('isLogout', 1)
				// console.log(res.msg, tips === true, tips, '退出登录成功')
				// true 不给提示语
				if (tips !== true) {
					setMessageQueue('success', tips || '退出登录成功')
				}
				// 登录失效 + 清缓存
				reset()
				return false
			}
		}).catch(e => {
			setMessageQueue('error', e)
			console.log(e)
		})
	} else {
		// 登录失效 + 清缓存
		reset(go)
	}
}

// 登录失效 + 清缓存
export function reset(go) {
	// console.log(go, 'reset go')
	// go 为401
	if (go) {
		// 再清除相关缓存
		localStorageRemove()
		setTimeout(() => {
			// 进入去登录页
			goLogin('', go)
			return
		}, 500)
	} else {
		router.push('/')
		// 再清除相关缓存
		localStorageRemove()
	}
}

// 再清除相关缓存
export function localStorageRemove() {
	localStorage.removeItem('userInfo')
	localStorage.removeItem('isLogin')
	localStorage.removeItem('token')
	localStorage.removeItem('loginToken')
	localStorage.removeItem('menuInitIndex')
	localStorage.removeItem('iconIndex')
	localStorage.removeItem('ticket')
	localStorage.removeItem('tabKeyOperation')
	useUserStore().isLogin = null
	useUserStore().userInfo = {}
	useUserStore().isMenu = false
	useUserStore().isCollapse = true
	useUserStore().isClick = false
	useUserStore().isHover = false
}

// 存入消息队列
export function setMessageQueue(type, message, clickType, duration) {
	console.log(messageQueue.value, 'messageQueue.value')
	messageQueue.value.push({
		type: type === 'error' || type === 'warning' ? 'info' : type, // 消息类型  20250626 新增 目前只有两种提示类型
		message: message, // 消息内容
		clickType: clickType ? (clickType + message) : '', // click + 模块名称 + 消息内容
		duration: duration, // 时长
	})
	if (messageQueue.value.length === 1) {
		// 调用递归函数开始显示消息
		showMessage.call(this, 0)
	}
}

// 递归函数，依次显示消息队列中的消息
export function showMessage(index) {
	if (index < messageQueue.value.length) {
		const messageItem = messageQueue.value[index]
		if (index > 0) {
			messageItemOld.value = messageQueue.value[index - 1]
		} else {
			messageItemOld.value = null
		}

		if (messageItemOld.value && messageItemOld.value.clickType === messageItem.clickType) {
			// 在消息关闭时递归显示下一个消息
			showMessage.call(this, index + 1)
			if (index + 1 === messageQueue.value.length) {
				messageQueue.value = []
			}
		} else {
			// console.log(useUserStore().countdown, 'useUserStore().countdown')
			ElMessage({
				type: messageItem.type,
				message: messageItem.message,
				duration: messageItem.duration || 2000, // 控制每个消息的显示时间
				offset: useUserStore().countdown > 0 ? 122 : 68, // 距离窗口顶部的偏移量 68 => 122 （有公告倒计时时高度）
				onClose: () => {
					setTimeout(() => {
						// 在消息关闭时递归显示下一个消息
						showMessage.call(this, index + 1)
						if (index + 1 === messageQueue.value.length) {
							messageQueue.value = []
						}
					}, 100)
				}
			})
		}
	}
}

// 列表时禁用文本选中 有type放行 可以选中文本
export function mousedownCommon(e, type) {
	// console.log(type, 'type')
	if (!type) {
		e.preventDefault()
	}
}

// 1 管理员 对已配置完成的功能进行日常处理并具有修改数据权利
// 2 用户 对已配置完成的功能进行日常处理，不具有修改数据权利。
// 3 仅查看 对已配置完成的功能进行查看翻阅，无法进行提交等日常处理事件
// 4 空状态 账户冻结无法登录，对功能配置关联失效，
// 获取角色权限 主账号（只能是管理员）子账号（管理员、用户、仅查看、空状态）
// 待定
export function getPermission(e) {
	// if (e === '') {
	// 	return
	// } else {

	// }
	// console.log(e, 'getPermission')
}

// 文件大小转换
export function formatBytes(bytes) {
	if (bytes >= 1073741824) {
		return (bytes / 1073741824).toFixed(2) + ' GB';
	} else if (bytes >= 1048576) {
		return (bytes / 1048576).toFixed(2) + ' MB';
	} else {
		return (bytes / 1024).toFixed(2) + ' KB';
	}
}

// 文件大小转换成G
export function formatBytesG(bytes) {
	let str = (bytes / 1073741824).toFixed(2)
	if (str === '0.00') {
		str = bytes ? '0.01' : ''
	}
	return str ? str + 'GB' : '';
}

// 文件大小转换成M 保留一位小数
export function formatBytesM(bytes) {
	if (bytes >= 1073741824) {
		return (bytes / 1073741824).toFixed(1) + ' GB';
	} else if (bytes >= 1048576) {
		return (bytes / 1048576).toFixed(1) + ' MB';
	} else {
		return '1.0 MB';
	}
}

// 文件大小转换 (项目追踪附件文件大小特殊展示) >999M=1G <1M = 1M 
export function formatBytesNew(bytes) {
	if (bytes >= 1047527424) {
		return (bytes / 1047527424).toFixed(1) + 'G';
	} else if (bytes >= 1048576) {
		return (bytes / 1048576).toFixed(0) + 'M';
	} else {
		return '1M';
	}
}

// 转换时间格式到分
export function formatTime(val, num) {
	return val ? val.substring(0, num || 16) : '-';
}

// 转换日期
export function formatDate(date) {
	return `${date.getFullYear()}-${(date.getMonth()+1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
}

// 上传图片校验
export function beforeUpload(rawFile) {
	const isImage = ['image/bmp', 'image/gif', 'image/jpeg', 'image/png', 'image/jpg'].includes(rawFile.type)
	// console.log(isImage, 'isImage')
	if (!isImage) {
		setMessageQueue('error', '仅支持上传图片格式！')
		return false
	} else if (rawFile.size / 1024 / 1024 > 10) {
		setMessageQueue('error', '上传文件请勿超过 10MB')
		return false
	}
	return true
}

// 下载公共方法
export function downMethods(response) {
	var res = response.data
	const headers = response.headers;
	const contentType = headers['content-type'];
	const contentDisposition = headers['content-disposition'];
	var blob = new Blob([res], {
		type: contentType
	});
	let downloadElement = document.createElement('a');
	let href = window.URL.createObjectURL(blob); //创建下载的链接
	downloadElement.href = href;
	// console.log(response, contentDisposition, 'response')
	// decodeURI 解决中文乱码问题 与后端配合解码
	if (contentDisposition) {
		let str = contentDisposition.split('.')[0]
		downloadElement.download = !isNaN(str) ? contentDisposition : decodeURI(contentDisposition); //下载后文件名
		document.body.appendChild(downloadElement);
		downloadElement.click(); //点击下载
		document.body.removeChild(downloadElement); //下载完成移除元素
		window.URL.revokeObjectURL(href); //释放掉blob对象
	}
}

// url文件下载开始接口
export function fileDownloadFileUrlApi(item, moduleName, functionName, fileName) {
	fileDownloadFileUrl({
		fileId: item.markImgId || item.fileId || item.id,
		moduleName,
		functionName
	}).then(res => {
		if (res) {
			fetch(res.data.fileUrl)
				.then(response => response.blob())
				.then(blob => {
					var url = URL.createObjectURL(blob);
					var a = document.createElement('a');
					a.href = url;
					// 文件名 20260302新增 fileName为实名认证/电子名片部分使用
					a.download = fileName || item.fileName || item.originalName || item.address;
					document.body.appendChild(a);
					a.click();
					document.body.removeChild(a);
					URL.revokeObjectURL(url);

					// 下载完成后的回调
					fileUpdateExportStatusApi(res.data.exportId)
					// console.log('文件下载完成fileDownloadFileUrl');
				}).catch(err => {
					console.log(err, '文件下载 err')
				})
		}
	}).catch(e => {
		setMessageQueue('error', e)
		console.log(e)
	})
}

// 下载完成后的回调
export function fileUpdateExportStatusApi(exportId) {
	fileUpdateExportStatus({
		exportId
	}).then(res => {
		if (res) {
			// console.log('文件下载完成fileUpdateExportStatus');
		}
	}).catch(e => {
		setMessageQueue('error', e)
		console.log(e)
	})
}

// 获取公共提示
export function getCommonTaskMessage(val) {
	// 1公版 内测版提示：请联系五十三线上服务站，获取更多任务脚本
	if (val) {
		setMessageQueue('info', '请联系五十三线上服务站，获取更多任务脚本')
	} else {
		setMessageQueue('info', '请联系五十三线上服务站，获取更多任务脚本')
	}
}

// 直接计算是否在最后一行
export function isLastRow(index, total, perRow = 5) {
	const totalRows = Math.ceil(total / perRow);
	const currentRow = Math.floor(index / perRow) + 1;
	return currentRow === totalRows;
}

// 20260422 替换文案
// 1 管理员 赋予已配置功能，设置、删除、创建、编辑、预览全量操作权限
// 2 用户 赋予已配置功能，删除、创建、编辑、预览操作权限
// 3 仅查看 赋予已配置功能，预览操作权限
// 4 空状态 账号冻结，登录权限失效
// 权限组 不同角色文案展示
export function switchPerssionGroupText(val) {
	let str = ''
	switch (val) {
		case 'admin':
			str = '管理员：赋予已配置功能，设置、删除、创建、编辑、预览全量操作权限'
			break;
		case 'user':
			str = '用户：赋予已配置功能，删除、创建、编辑、预览操作权限'
			break;
		case 'only_show':
			str = '仅查看：赋予已配置功能，预览操作权限'
			break;
		case 'empty':
			str = '空状态：账号冻结，登录权限失效'
			break;
	}
	return [str]
}

// // 转换项目状态status class
// export function switchProjectStatusClass(index) {
// 	let str = ''
// 	switch (index) {
// 		case '1':
// 			str = 'dwcBloSty'
// 			break;
// 		case '2':
// 			str = 'dysBloSty'
// 			break;
// 		case '3':
// 			str = 'ywcBloSty'
// 			break;
// 		case '4':
// 			str = 'fkqBloSty'
// 			break;
// 	}
// 	return str
// }

// 转换项目状态status class
export const switchProjectStatusClass = {
	'1': 'dwcBloSty',
	'2': 'dysBloSty',
	'3': 'ywcBloSty',
	'4': 'fkqBloSty',
};

// // 转换项目状态status back class
// export function switchProjectStatusBackClass(index) {
// 	let str = ''
// 	switch (index) {
// 		case '1':
// 			str = 'dwcBloBackSty'
// 			break;
// 		case '2':
// 			str = 'dysBloBackSty'
// 			break;
// 		case '3':
// 			str = 'ywcBloBackSty'
// 			break;
// 		case '4':
// 			str = 'fkqBloBackSty'
// 			break;
// 	}
// 	return str
// }

// 转换项目状态status back class
export const switchProjectStatusBackClass = {
	'1': 'dwcBloBackSty',
	'2': 'dysBloBackSty',
	'3': 'ywcBloBackSty',
	'4': 'fkqBloBackSty',
};

// // 转换项目状态status active class
// export function switchProjectStatusActiveClass(index) {
// 	let str = ''
// 	switch (index) {
// 		case '1':
// 			str = 'dwcBloBackActiveSty'
// 			break;
// 		case '2':
// 			str = 'dysBloBackActiveSty'
// 			break;
// 		case '3':
// 			str = 'ywcBloBackActiveSty'
// 			break;
// 		case '4':
// 			str = 'fkqBloBackActiveSty'
// 			break;
// 	}
// 	return str
// }

// 转换项目状态status active class
export const switchProjectStatusActiveClass = {
	'1': 'dwcBloBackActiveSty',
	'2': 'dysBloBackActiveSty',
	'3': 'ywcBloBackActiveSty',
	'4': 'fkqBloBackActiveSty',
};

// // 转换项目状态status 文本
// export function switchProjectStatusText(index) {
// 	let str = ''
// 	switch (index) {
// 		case '1':
// 			str = '待完成'
// 			break;
// 		case '2':
// 			str = '待验收'
// 			break;
// 		case '3':
// 			str = '已完成'
// 			break;
// 		case '4':
// 			str = '风控区'
// 			break;
// 	}
// 	return str
// }

// 转换项目状态status 文本
export const switchProjectStatusText = {
	'1': '待完成',
	'2': '待验收',
	'3': '已完成',
	'4': '风控区',
};

// // 转换优先级level
// export function switchLevelClass(index) {
// 	let str = ''
// 	switch (index) {
// 		case 'Low':
// 			str = 'LowSty'
// 			break;
// 		case 'Middle':
// 			str = 'MiddleSty'
// 			break;
// 		case 'Critical':
// 			str = 'CriticalSty'
// 			break;
// 		case 'High':
// 			str = 'HighSty'
// 			break;
// 	}
// 	return str
// }

// 转换优先级level
export const switchLevelClass = {
	'Low': 'LowSty',
	'Middle': 'MiddleSty',
	'Critical': 'CriticalSty',
	'High': 'HighSty',
};

// 根据当前个数获取背景色
export function switchBack(index) {
	let str = ''
	switch (index) {
		case 0:
			str = 'backF'
			break;
		case 1:
			str = 'backS'
			break;
		case 2:
			str = 'backT'
			break;
		case 3:
			str = 'backFour'
			break;
		case 4:
			str = 'backFir'
			break;
		default:
			break;
	}
	return str
}

// 权限组转换成文字
export function permissionGroupText(val) {
	let str = ''
	switch (val) {
		case 'admin':
			str = '管理员'
			break;
		case 'user':
			str = '用户'
			break;
		case 'only_show':
			str = '仅查看'
			break;
		case 'empty':
			str = '空状态'
			break;
		case '':
			str = '空状态'
			break;
	}
	return str
}

// 认证状态转换成文字（20250923 改为接口动态获取）
export function rzStatusText(val) {
	let str = ''
	switch (val) {
		case 1:
			str = '试用期'
			break;
		case 2:
			str = '测试'
			break;
		case 3:
			str = '临时'
			break;
		case 4:
			str = '实习'
			break;
		case 5:
			str = '已认证'
			break;
		default:
			break;
	}
	return str
}

// 认证状态转class
export function rzStatusClass(val) {
	let str = ''
	switch (val) {
		case 1:
			str = 'syqSty' // 试用期
			break;
		case 2:
			str = 'csSty' // 测试
			break;
		case 3:
			str = 'lsSty' // 临时
			break;
		case 4:
			str = 'sxSty' // 实习
			break;
		case 5:
			str = 'yrzSty' // 已认证
			break;
		default:
			break;
	}
	return str
}

// 站内信状态转换成文字
export function znxStatusText(val) {
	let str = ''
	switch (val) {
		case 1:
			str = '企业信息'
			break;
		case 2:
			str = '系统信息'
			break;
		default:
			break;
	}
	return str
}

// 站内信状态转class
export function znxStatusClass(val) {
	let str = ''
	switch (val) {
		case 1:
			str = 'qyxxSty' // 企业信息
			break;
		case 2:
			str = 'xtSty' // 系统信息
			break;
		default:
			break;
	}
	return str
}

// 服务站状态class
export function switchStatusClass(val) {
	let str = ''
	switch (val) {
		case 1:
			str = 'dclSty' // 待处理
			break;
		case 2:
			str = 'clzSty' // 处理中
			break;
		case 3:
			str = 'yjsSty' // 已结单
			break;
		default:
			break;
	}
	return str
}

// 服务站状态转换成文字
export function switchStatusText(val) {
	let str = ''
	switch (val) {
		case 1:
			str = '待处理'
			break;
		case 2:
			str = '处理中'
			break;
		case 3:
			str = '已结单'
			break;
		default:
			break;
	}
	return str
}

// 导出列队-导出状态class
export function switchExportStatusClass(val) {
	let str = ''
	switch (val) {
		case 1:
			str = 'cursorColor' // 完成
			break;
		case 2:
			str = 'yjsSty' // 进行中
			break;
		case 3:
			str = 'clzSty' // 中断
			break;
		default:
			break;
	}
	return str
}

// 导出列队-导出状态转换成文字
export function switchExportStatusText(val) {
	let str = ''
	switch (val) {
		case 1:
			str = '完成'
			break;
		case 2:
			str = ''
			break;
		case 3:
			str = '中断'
			break;
		default:
			break;
	}
	return str
}

// 转换支付方式 支付宝/微信/积分兑换
export function switchPayMethod(val) {
	let str = ''
	switch (val) {
		case 1:
			str = '支付宝'
			break;
		case 2:
			str = '微信'
			break;
		case 3:
			str = '积分兑换'
			break;
		default:
			break;
	}
	return str
}

// 认证状态转换成文字
export function approvalStatusText(val) {
	let str = ''
	switch (val) {
		case 1:
			str = '审核中'
			break;
		case 2:
			str = '通过'
			break;
		case 3:
			str = '否决'
			break;
		default:
			break;
	}
	return str
}

// 审批状态转class
export function approvalStatusClass(val) {
	let str = ''
	switch (val) {
		case 1:
			str = 'inApprovalSty' // 审核中
			break;
		case 2:
			str = 'passSty' // 通过
			break;
		case 3:
			str = 'rejectSty' // 否决
			break;
		default:
			break;
	}
	return str
}

// 审批状态带背景转class
export function approvalStatusBackClass(val) {
	let str = ''
	switch (val) {
		case 2:
			str = 'passBackSty' // 通过
			break;
		case 3:
			str = 'rejectBackSty' // 否决
			break;
		default:
			break;
	}
	return str
}

// 文字转换成type
export function switchType(val) {
	if (val.indexOf('成员') > -1) {
		return 'exportMember'
	} else if (val.indexOf('综合') > -1) {
		return 'exportOverall'
	} else if (val.indexOf('预警') > -1) {
		return 'exportWarning'
	} else if (val.indexOf('登记') > -1 || val.indexOf('设备导出') > -1) {
		return 'exportDeviceRegister'
	} else if (val.indexOf('审批') > -1) {
		return 'exportDeviceApply'
	} else if (val.indexOf('档案删除') > -1) {
		return 'archiveDeletePermit'
	} else if (val.indexOf('设备删除') > -1) {
		return 'deviceDeletePermit'
	} else if (val.indexOf('档案库数据变更') > -1) {
		return 'archiveLockPermit'
	} else if (val.indexOf('档案可见') > -1) {
		return 'memberLock'
	}
}

// 文字转换成mess
export function switchMess(val) {
	if (val.indexOf('成员') > -1) {
		return '导出许可(成员档案)'
	} else if (val.indexOf('综合') > -1) {
		return '导出许可(综合档案)'
	} else if (val.indexOf('预警') > -1) {
		return '导出许可(到期预警)'
	} else if (val.indexOf('登记') > -1 || val.indexOf('设备导出') > -1) {
		return '导出许可(设备登记)'
	} else if (val.indexOf('审批') > -1) {
		return '导出许可(设备审批)'
	} else if (val.indexOf('推送') > -1) {
		return '结果推送'
	} else if (val.indexOf('档案删除') > -1) {
		return '档案删除许可'
	} else if (val.indexOf('设备删除') > -1) {
		return '设备删除许可'
	} else if (val.indexOf('档案库数据变更') > -1) {
		return '档案库数据变更许可'
	} else if (val.indexOf('档案可见') > -1) {
		return '档案可见锁定许可'
	}
}

// 执行结果转换成文字 
export function swicthRresultFlagText(val) {
	let str = ''
	switch (val) {
		case 1:
			str = 'True'
			break;
		case 2:
			str = 'False'
			break;
		case 3:
			str = 'Null'
			break;
		default:
			break;
	}
	return str
}

// 执行结果转class
export function swicthRresultFlagClass(val) {
	let str = ''
	switch (val) {
		case 1:
			str = 'yjsSty' // True
			break;
		case 2:
			str = 'rejectSty' // False
			break;
		case 3:
			str = 'color_B9B' // Null
			break;
		default:
			break;
	}
	return str
}